import { network } from 'services/network';

export const getFinishDateDueToEditStartDateOrDuration = (params) => {
    return network.post('api/bo/getFinishDateDueToEditStartDateOrDuration', params).then((response) => {
        return response.data;
    });
};
